export default {
  computed: {
    getDialog() {
      return this.$store.getters["dialog/getDialog"];
    },
    getNotifyData() {
      return this.$store.getters["dialog/getNotifyData"];
    },
    getPlayViewMachine() {
      return this.$store.getters["dialog/getPlayViewMachine"];
    },
  },
  methods: {
    openDialog(name) {
      this.$store.commit("dialog/setDialog", {
        [name]: true,
      });
    },
    closeDialog(name) {
      this.$store.commit("dialog/setDialog", {
        [name]: false,
      });
    },
    setDialog(name, value) {
      this.$store.commit("dialog/setDialog", {
        [name]: value,
      });
    },
    showNotifyDialog(message) {
      this.$store.commit("dialog/setNotifyMessage", message);
      this.$store.commit("dialog/setDialog", {
        notify: true,
      });
    },
    setPlayViewMachine(machine) {
      this.$store.commit("dialog/setPlayViewMachine", machine);
    },
  },
};
